import { NextFontWithVariable } from 'next/dist/compiled/@next/font';
import { Comfortaa, DM_Sans, Open_Sans, Poppins, Roboto, Work_Sans, Merriweather, Inter } from 'next/font/google';
import localFont from 'next/font/local';

const dmSans = DM_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--custom-font-dm-sans',
  preload: false
});

const roboto = Roboto({
  subsets: ['latin'],
  display: 'swap',
  weight: ['400', '500', '700'],
  variable: '--custom-font-roboto',
  preload: false
});

const openSans = Open_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--custom-font-open-sans',
  preload: false
});

const poppins = Poppins({
  subsets: ['latin'],
  display: 'swap',
  weight: ['600'],
  variable: '--custom-font-poppins',
  preload: false
});

const workSans = Work_Sans({
  subsets: ['latin'],
  display: 'swap',
  variable: '--custom-font-work-sans',
  preload: false
});

const comfortaa = Comfortaa({
  subsets: ['latin'],
  display: 'swap',
  variable: '--custom-font-comfortaa',
  preload: false
});

const merriweather = Merriweather({
  subsets: ['latin'],
  display: 'swap',
  weight: ['300'],
  variable: '--custom-font-merriweather',
  preload: false
});

const inter = Inter({
  subsets: ['latin'],
  display: 'swap',
  weight: ['600', '400'],
  variable: '--custom-font-inter',
  preload: false
});

const futuraPT = localFont({
  src: [
    {
      path: './fonts/FuturaCyrillicBook.woff2',
      weight: '350',
      style: 'normal'
    },
    {
      path: './fonts/FuturaCyrillicMedium.woff2',
      weight: '500',
      style: 'bold'
    }
  ],
  variable: '--custom-font-futura-pt',
  preload: false
});

const recifeText = localFont({
  src: [
    {
      path: './fonts/RecifeText-SemiBold.woff2',
      weight: '600',
      style: 'normal'
    },
    {
      path: './fonts/RecifeText-SemiBoldItalic.woff2',
      weight: '600',
      style: 'italic'
    }
  ],
  variable: '--custom-font-recife-text',
  preload: false
});

const fontAwesome6ProBrands = localFont({
  src: './fonts/FontAwesome6Brands-Regular.woff2',
  display: 'swap',
  variable: '--custom-font-font-awesome-6-pro-brands',
  preload: false
});

const fontAwesome6Pro = localFont({
  src: './fonts/FontAwesome6Pro-Regular.woff2',
  display: 'swap',
  weight: '400',
  variable: '--custom-font-font-awesome-6-pro',
  preload: false
});

const themeFontMap: Record<string, NextFontWithVariable[]> = {
  acumen: [],
  'ba-polymers': [poppins, openSans],
  cpa: [roboto],
  diarkis: [workSans, recifeText, merriweather],
  entec: [inter],
  ravago: [roboto],
  'ravago-one': [roboto],
  resinex: [roboto],
  ultrapolymers: [roboto],
  oceanworks: [roboto, dmSans],
  vidara: [futuraPT, comfortaa]
};

export const loadFonts = (theme: string): string => [...(themeFontMap[theme] ?? []), fontAwesome6Pro, fontAwesome6ProBrands].map((font) => font.variable).join(' ');
